export const AVAILABLE_COUNTRY_CODES = [
  'BE',
  'CH',
  'DE',
  'ES',
  'FR',
  'GB',
  'IT',
  'NL',
  'PT',
] as const;

export type CountryCode = (typeof AVAILABLE_COUNTRY_CODES)[number];
